// extracted by mini-css-extract-plugin
export default {"titles":"_7em1LRSTMrdNlxPnQkVf","title":"jcNBTFYGmJu0aFgUNXgw","subTitle":"nkr0U7rGiCvDwt2iYjaH"};